export const DESC_SMALL_DATETIME_FORMAT = 'llll';  // mié., 19 de oct. de 2022 23:43
export const DESC_DATETIME_FORMAT = 'LLLL';  // miércoles, 19 de octubre de 2022 23:43